"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.date = date;
exports.time = time;
exports.fullDate = fullDate;
exports.getHumanized = getHumanized;
exports.add = add;
exports.year = year;
exports.expiryDate = expiryDate;
exports.toApiDate = toApiDate;
exports.getGreeting = getGreeting;
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function date(dateValue) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/Y';
  return (0, _moment["default"])(dateValue).format(format);
}

function time(dateValue) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'H:m';
  return (0, _moment["default"])(dateValue).format(format);
}

function fullDate(dateValue) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD MMM YYYY, HH:mm';
  return (0, _moment["default"])(dateValue).format(format);
}

function getHumanized(dateValue) {
  return date(dateValue, 'ddd, MMM Do');
}

function add(date, count, intervals) {
  if (date == null) {
    date = (0, _moment["default"])();
  }

  return (0, _moment["default"])(date).add(count, intervals);
}

function year() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!date) {
    return (0, _moment["default"])().year();
  }

  return (0, _moment["default"])(date).year();
}

function expiryDate(dateValue) {
  return date(dateValue, 'MM/YYYY');
}

function toApiDate(dateValue) {
  var fromFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return (0, _moment["default"])(dateValue, fromFormat).format('YYYY-MM-DD');
}
/**
 * TODO: Return greeting by time
 */


function getGreeting() {
  var today = new Date();
  var curHr = today.getHours();

  if (curHr < 12) {
    return 'Good morning';
  } else if (curHr < 18) {
    return 'Good afternoon';
  } else {
    return 'Good evening';
  }
}

var _default = {
  date: date,
  time: time,
  fullDate: fullDate,
  getHumanized: getHumanized,
  add: add,
  expiryDate: expiryDate,
  toApiDate: toApiDate,
  getGreeting: getGreeting,
  year: year
};
exports["default"] = _default;